// Header.jsx
import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import Logo from '../common/Logo';

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <header
      className="header"
      style={{
        background: isDark
          ? 'rgba(12, 20, 40, 0.85)'
          : 'rgba(232, 237, 245, 0.88)',
        backdropFilter: 'blur(20px) saturate(180%)',
        WebkitBackdropFilter: 'blur(20px) saturate(180%)',
        borderBottom: isDark
          ? '1px solid rgba(30, 48, 90, 0.50)'
          : '1px solid rgba(255, 255, 255, 0.65)',
        boxShadow: isDark
          ? '0 4px 20px rgba(4,8,20,.55), 0 1px 0 rgba(22,38,72,.35)'
          : '0 4px 16px rgba(163,177,198,.30), 0 1px 0 rgba(255,255,255,.75)',
      }}
    >
      <h1 style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <Logo size={32} showGlow={isDark} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          <span style={{
            background: isDark 
              ? '#0b142d' 
              : 'linear-gradient(135deg, #1b2a6b 30%, #00c9a7)',
            WebkitBackgroundClip: isDark ? 'unset' : 'text',
            WebkitTextFillColor: isDark ? 'unset' : 'transparent',
            backgroundClip: isDark ? 'unset' : 'text',
            color: isDark ? 'white' : 'unset',
            letterSpacing: '-0.5px',
            fontSize: '1.25rem',
            fontWeight: 800,
            lineHeight: 1.1,
            textShadow: isDark ? '0 0 12px rgba(255,255,255,0.15)' : 'none',
          }}>
            Yeldi
          </span>
          <span style={{
            fontSize: '0.58rem',
            fontWeight: 700,
            color: isDark ? '#00c9a7' : 'var(--yeldi-teal)',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '0.28rem',
          }}>
            <span style={{
              width: 5,
              height: 5,
              borderRadius: '50%',
              background: isDark ? '#00c9a7' : 'var(--yeldi-teal)',
              boxShadow: isDark 
                ? '0 0 8px #00c9a7' 
                : '0 0 6px var(--yeldi-teal)',
              display: 'inline-block',
            }}/>
            En ligne
          </span>
        </div>
      </h1>

      <div className="header-actions">
        <button
          onClick={toggleTheme}
          className="header-icon-btn"
          aria-label={isDark ? 'Activer le mode clair' : 'Activer le mode sombre'}
          style={{
            width: 38,
            height: 38,
            borderRadius: '50%',
            border: 'none',
            background: 'var(--bg)',
            color: 'var(--text-2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: 'var(--neu-sm)',
            transition: 'all var(--ease)',
          }}
        >
          {isDark ? <Sun size={17} strokeWidth={2}/> : <Moon size={17} strokeWidth={2}/>}
        </button>
      </div>
    </header>
  );
};

export default Header;